export default __webpack_public_path__ + "static/media/logo23.d20b0414.png";